var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './index.scss';
import { bool, func } from 'prop-types';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GeniusButton from '~/components/genius_button';
import GeniusModal from '~/components/genius_modal';
import { useUser } from '~/providers/user';
import { setIsExportingComparison } from '~/redux/reducers/states/comparison_documents';
const ExportModal = ({ isOpen, onSubmit, setIsOpen }) => {
    ExportModal.propTypes = {
        isOpen: bool.isRequired,
        onSubmit: func.isRequired,
        setIsOpen: func.isRequired,
    };
    const dispatch = useDispatch();
    const { isExportingComparison } = useSelector(state => state.comparisonDocumentsState);
    const { privilegeGroups: userPrivilegeGroups } = useUser();
    const [exportDiffs, setExportDiffs] = useState();
    const [exportPrivilegedComments, setExportPrivilegedComments] = useState(userPrivilegeGroups.length ? undefined : false);
    const [selectedPrivilegeGroupIds, setSelectedPrivilegeGroupIds] = useState([]);
    const [isUserPromptShowing, setIsUserPromptShowing] = useState(false);
    const handleClose = () => {
        setIsOpen(false);
        setExportDiffs(undefined);
        setExportPrivilegedComments(userPrivilegeGroups.length ? undefined : false);
        setIsUserPromptShowing(false);
        setSelectedPrivilegeGroupIds([]);
    };
    const headerContent = (React.createElement("div", { id: 'export-modal-header-container' },
        React.createElement("div", { className: 'modal-header-text' },
            React.createElement("b", null, "EXPORT DATA"))));
    const handleIncludeRedlineChange = event => {
        if (isUserPromptShowing && exportPrivilegedComments !== undefined) {
            setIsUserPromptShowing(false);
        }
        setExportDiffs(event.target.value === 'true');
    };
    const handleIncludePrivilegedCommentsChange = event => {
        if (isUserPromptShowing && exportDiffs !== undefined) {
            setIsUserPromptShowing(false);
        }
        if (exportPrivilegedComments && selectedPrivilegeGroupIds.length) {
            setSelectedPrivilegeGroupIds([]);
        }
        setExportPrivilegedComments(event.target.value === 'true');
    };
    const handleToggleSelectedGroup = event => {
        const privilegeGroupId = event.target.value;
        setSelectedPrivilegeGroupIds((selectedPrivilegeGroupIds === null || selectedPrivilegeGroupIds === void 0 ? void 0 : selectedPrivilegeGroupIds.find(x => x === privilegeGroupId))
            ? selectedPrivilegeGroupIds.filter(x => x !== privilegeGroupId)
            : [...selectedPrivilegeGroupIds, privilegeGroupId]);
    };
    const buildSelectedGroupsList = () => {
        return userPrivilegeGroups.map(privilegeGroup => {
            return (React.createElement("div", { key: `privilege-group-selector-${privilegeGroup.id}` },
                React.createElement("div", { className: 'select-group', onChange: handleToggleSelectedGroup },
                    React.createElement("input", { type: "checkbox", id: `${privilegeGroup.name}-checkbox-button`, name: privilegeGroup.name, value: privilegeGroup.id }),
                    privilegeGroup.displayName)));
        });
    };
    const bodyContent = (React.createElement("div", { id: 'export-modal-body-container' },
        React.createElement("div", { className: 'modal-prompt', id: 'redline-prompt' },
            "Include redline?",
            React.createElement("div", { className: 'prompt-button-container', onChange: handleIncludeRedlineChange },
                React.createElement("div", { className: 'modal-prompt-option' },
                    React.createElement("input", { type: "radio", id: "redline-affirmative", name: "include-redline", value: true }),
                    React.createElement("div", null, "Yes")),
                React.createElement("div", { className: 'modal-prompt-option' },
                    React.createElement("input", { type: "radio", id: "redline-negative", name: "include-redline", value: false }),
                    React.createElement("div", null, "No")))),
        !!userPrivilegeGroups.length &&
            React.createElement("div", { className: 'modal-prompt', id: 'privileged-comments-prompt' },
                "Include privileged comments?",
                React.createElement("div", { className: 'prompt-button-container', onChange: handleIncludePrivilegedCommentsChange },
                    React.createElement("div", { className: 'modal-prompt-option' },
                        React.createElement("input", { type: "radio", id: "privileged-comments-affirmative", name: "include-privileged-comments", value: true }),
                        React.createElement("div", null, "Yes")),
                    React.createElement("div", { className: 'modal-prompt-option' },
                        React.createElement("input", { type: "radio", id: "privileged-comments-negative", name: "include-privileged-comments", value: false }),
                        React.createElement("div", null, "No")))),
        isUserPromptShowing &&
            React.createElement("div", { id: 'user-input-prompt' }, "Please select yes or no above"),
        !!userPrivilegeGroups.length && exportPrivilegedComments &&
            React.createElement("div", { id: 'select-privileged-groups-container' },
                React.createElement("div", { id: 'select-groups-header' },
                    React.createElement("b", null, "SELECT GROUPS")),
                React.createElement("div", { id: 'select-groups-list' }, buildSelectedGroupsList()))));
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (exportDiffs === undefined || exportPrivilegedComments === undefined) {
            setIsUserPromptShowing(true);
            return;
        }
        dispatch(setIsExportingComparison(true));
        onSubmit({ exportDiffs, exportPrivilegedComments, selectedPrivilegeGroupIds });
    });
    const footerContent = (React.createElement("div", { id: 'export-modal-footer-container' },
        React.createElement(GeniusButton, { id: 'export-modal-submit-button', onClick: handleSubmit, key: isExportingComparison ? 'exporting-comparison' : 'not-exporting-comparison', textBlock: isExportingComparison
                ? React.createElement("span", { className: 'fas fa-spinner fa-pulse' })
                : React.createElement("b", null, "Export To Excel") })));
    return (React.createElement(GeniusModal, { isModalShowing: isOpen, onHide: handleClose, headerContent: headerContent, bodyContent: bodyContent, footerContent: footerContent }));
};
export default ExportModal;
